import axios from 'axios'

export const reqPost = async (url, token, body, callback) => {
  axios.post(url, body, {
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      "Authorization": " Bearer " + token,
    },
  }).then(function (response) {
    callback(response.data);
  }).catch(function (error) {
      if (error.response) {
        callback(error.response.data);
      } else {
        // Something happened in setting up the request that triggered an Error
        callback(null);
      }
    })
};

export const post = async (url, token, body) => {
    try {
        const res = await axios.post(url, body, {
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
                "Authorization": " Bearer " + token,
            },
        });

        return res?.data;
    } catch (error) {
        return error?.response?.data || null;
    }
};

export const reqGet = async (url, token, callback) => {
  axios.get(url, {
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      "Authorization": " Bearer " + token,
    },
  }).then(function (response) {
    callback(response.data);
  })
    .catch(function (error) {
      if (error.response) {
        callback(error.response.data);
      } else {
        // Something happened in setting up the request that triggered an Error
        callback(null);
      }
    })
};


  export const getfilename = function (url) {
    return url.substring(url.lastIndexOf('/')+1);
  }
  